import { CUSTOMER_SERVICE_LOCATION_APPROXIMATE_ADDRESS_MAX_LENGTH } from './puertoRicoMunicipalities';

const addressCache = new Map();

const coordinateKey = ({ lat, lng }) => `${lat.toFixed(6)},${lng.toFixed(6)}`;

export const normalizeApproximateMapAddress = value => {
  if (typeof value !== 'string') return '';
  return value
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, CUSTOMER_SERVICE_LOCATION_APPROXIMATE_ADDRESS_MAX_LENGTH);
};

/** Reverse geocodes one Puerto Rico point and retains only a short display string. */
export const reverseGeocodePuertoRico = (origin, locale = 'es') => {
  const key = coordinateKey(origin);
  if (addressCache.has(key)) return addressCache.get(key);

  const libLoaded = typeof window !== 'undefined' && window.mapboxSdk && window.mapboxgl;
  if (!libLoaded || !window.mapboxgl.accessToken) return Promise.resolve('');

  const client = window.mapboxSdk({ accessToken: window.mapboxgl.accessToken });
  const request = client.geocoding
    .reverseGeocode({
      query: [origin.lng, origin.lat],
      countries: ['pr'],
      language: [locale],
      limit: 1,
    })
    .send()
    .then(response => normalizeApproximateMapAddress(response?.body?.features?.[0]?.place_name))
    .catch(() => '');

  addressCache.set(key, request);
  return request;
};

export const clearReverseGeocodingCache = () => addressCache.clear();
